import {Component, inject} from '@angular/core';
import { SearchService } from '../../services/search.service';
import { environment } from '../../../environments/environment';
import { AuthService, IStorageItem } from '../../services/auth.service';
import { IDocument } from '../../interfaces/document.interface';
import { Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { Title } from '@angular/platform-browser';
import {UvtService} from "../../services/uvt.service";
import {ModalesService} from "../../services/modales.service";

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrl: './search.component.scss'
})
export class SearchComponent {
    title = 'Consulte si debe declarar renta';
    errorModalMessage = 'Verifique que registró correctamente los datos de su documento.';
    siteKey = environment.captchaPublic;
    loader = false;
    error = false;
    errorLink = '';
    errorLinkLabel = '';
    retriesAfter401 = 0;
    retryLimits = 1;
    tratamientoDatosIsOpen = false;
    consultarRenta= false;

    private searchService = inject(SearchService);
    private authService = inject(AuthService);
    private router = inject(Router);
    private browserTitle = inject(Title);
    private uvtService = inject(UvtService);
    private modalesService = inject(ModalesService);

    constructor(){
        const vigencia = new Date().getFullYear()-1;
        this.browserTitle.setTitle(environment.tituloBusqueda+vigencia);
        this.errorLink = environment.contactoErrorLink;
        this.errorLinkLabel = environment.contactoErrorLinkLabel;
        this.retryLimits = environment.retryAfter401;
        this.consultarUvt();
        this.authService.expiryToken();

    }

    onSearchSubmit(data: any, reTry = false) {

        if (data.resultado.codigo === 'E02'){
            this.modalesService.openModalError(
                'Atención',
                'Señor contribuyente no aprobó las preguntas de seguridad y no se puede verificar si usted es candidato a presentar renta.', null);
        }
        if (data.resultado.codigo === 'E03'){
            this.modalesService.openModalError(
                'Atención',
                'Señor contribuyente completó el número de intentos de las preguntas de seguridad y no se puede verificar si usted es candidato a presentar renta. Intente de nuevo.', null);
        }
        if (data.resultado.codigo === 'E04'){
            this.modalesService.openModalError(
                'Atención',
                'Al no encontrar preguntas de seguridad y no se puede verificar si usted es candidato a presentar renta.', null);
        }if (data.resultado.codigo === 'E05'){
            this.modalesService.openModalError(
                'Atención',
                'Con el número de identificación no se encontraron preguntas y no se puede verificar si usted es candidato a presentar renta. .', null);
        }if (data.resultado.codigo === 'E06'){
            const storedToken:IStorageItem | null = reTry ? null : this.authService.getWithTTL();
            if (storedToken)
            this.authService.expiryToken();

            this.modalesService.openModalError(
                'Atención',
                'Por vencimiento del token intente de nuevo', null);
        }if (data.resultado.codigo === 'E07'){
            this.modalesService.openModalError(
                'Atención',
                'No se completo la consulta, por un inconveniente técnico, intente más tarde.', null);
        }if (data.resultado.codigo === 'E08'){
            this.modalesService.openModalError(
                'Atención',
                'No se enviaron correctamente los parámetros, recargue e intente más tarde.', null);
        }if (data.resultado.codigo === 'E01') {
            this.consultarRenta = true;
        }
        //this.loader = true;

        const storedToken:IStorageItem | null = reTry ? null : this.authService.getWithTTL();
        if(!storedToken) {

            this.authService.getToken(data.reCaptcha).subscribe({
                next: (response: any) => {
                    const sItem = this.authService.setWithTTL(response.idToken, response.clientId, response.expireIn);
                    if (this.consultarRenta)
                        this.getDocumentInfo(sItem, data);
                },
                error: (error: any) => {
                    console.error("Error en la autenticación."+error);
                    //this.handleRequestError(error);
                }
            });
        } else {
            if (this.consultarRenta)
                this.getDocumentInfo(storedToken, data);
        }
    }

    getDocumentInfo(storageItem: IStorageItem, document: IDocument) {

       const doc = {
             numDocumento: document.numDocumento?.toString(),
             tipoDocumento: document.tipoDocumento,
             reCaptcha: document.reCaptcha

         };
        //console.log(`USO 2 ${doc.reCaptcha}]`)

        this.searchService.getDocumentInfo(storageItem, doc).subscribe({
            next: (response: any)=> {
                this.openLoader();
                this.handleResponse(response);
            },
            error: (error) => {
                console.error(`Error ${error?.error?.respuesta?.codigo} en la consulta: ${error?.error?.respuesta?.mensaje}.`);
                /* // TODO PARA SIGUIENTE VERSION SE REVISA CASO DE NO TENER RESULTADOS.
                if(error?.error?.respuesta?.codigo === 404 && error?.error?.respuesta?.mensaje.includes('No existen resultados')) {
                    this.modalesService.openModalError(
                        'Atención',
                        'EL contribuyente con el número de identificación no cuenta en este momento con la información suficiente para ' +
                        'determinar si debe declarar renta por este año, intente en otro momento.', null);
                    return ;
                }*/
                if(error?.error?.respuesta?.codigo === 404) {
                    this.handleResponse({});
                } else if (error?.error?.respuesta?.codigo === 401 && this.retryLimits > 0 && this.retriesAfter401 < this.retryLimits) {
                    this.retriesAfter401++;
                    console.info('Obteniendo nueva identidad, intento numero: '+this.retriesAfter401);
                    //retry refreshing the token
                    this.onSearchSubmit(doc, true);
                } else {
                    this.handleRequestError(error);
                }
            }
        });
    }

    handleResponse(response:any){
        const consultObject = this.makeConsultObjectFromResposne(response);
        if(consultObject) {
            this.router.navigate(['consulta'], { state: consultObject });
        } else {
            this.handleRequestError();
        }
    }

    makeConsultObjectFromResposne(response: any): any | null {
        let output = null;

        try {
            output = {
                numDocumento: response?.data?.numDocumento ? response?.data?.numDocumento : '',
                numeroNit : response?.data?.nit === null || response?.data?.nit === undefined  ? '' : response?.data?.nit,
                nit: response?.data?.nit !== null && response?.data?.nit !== 0 && response?.data?.nit !== '' && response?.data?.nit !== undefined,
                tipoDocumento: response?.data?.tipoDocumento === null || response?.data?.tipoDocumento === undefined ? '' : response?.data?.tipoDocumento,
                name: response?.data?.razonSocial === null || response?.data?.razonSocial === undefined  ? '' : response?.data?.razonSocial,
                plazo: response?.data?.plazo === null || response?.data?.plazo === undefined ? false : response?.data?.plazo,
                declara: response?.data?.ident === 0 || response?.data?.ident === undefined ? false : true,
                conditions: {
                    ident1: response?.data?.ident1 == null || response?.data?.ident1 == undefined ? false : response?.data?.ident1,
                    ident2: response?.data?.ident2 == null || response?.data?.ident2 == undefined ? false : response?.data?.ident2,
                    ident3: response?.data?.ident3 == null || response?.data?.ident3 == undefined ? false : response?.data?.ident3,
                    ident4: response?.data?.ident4 == null || response?.data?.ident4 == undefined ? false : response?.data?.ident4,
                    ident5: response?.data?.ident5 == null || response?.data?.ident5 == undefined ? false : response?.data?.ident5,
                    ident6: response?.data?.ident6 == null || response?.data?.ident6 == undefined ? false : response?.data?.ident6,
                }
            };
        } catch (error) {
            console.error("Error al recibir la respuesta, formato inesperado.")
        }

        return output;

    }

    handleRequestError(error?: HttpErrorResponse) {
        this.closeLoader();
        //this.openError();
        this.modalesService.openModalError(
            'Atención',
            'La consulta de renta sobre los datos registrados genero un error técnico, intente más tarde.', null);
        console.error(error)
        return ;
    }

    openLoader(){
        this.loader = true;
    }

    closeLoader(){
        this.loader = false;
    }

    openError(){
        this.error = true;
    }

    closeError() {
        this.error = false;
    }

    openTratamientoDatos() {
        this.tratamientoDatosIsOpen = true;
    }

    closeTratamientoDatos() {
        this.tratamientoDatosIsOpen = false;
    }
    private consultarUvt() {
        this.uvtService.getValuesUvt().subscribe({
            next: (data: any[]) => {
                const uvts = data;
                const vigenciaRenta = new Date().getFullYear() - 1;
                this.uvtService.uvtValues  = uvts.find(item => item.vigencia === vigenciaRenta);
            },
            error: (error: any) => {
                console.error("Error en la consulta de UVT."+error);
            }
        })
    }

    private validarToken() {

    }
}
